import React, { createContext, useContext, useMemo } from 'react';
import type { Dispatch } from 'react';
import type { DevAction, DevDomainConfig, DevState } from '../types/developmentDemo';
import { useDemoStore } from '../utils/demoStorage';
import { createDevReducer, createInitialDevState, devStorageKey } from '../utils/developmentDemo';
type DevelopmentDemoValue = {
  config: DevDomainConfig;
  state: DevState;
  dispatch: Dispatch<DevAction>;
  reset: () => void;
  persistenceOk: boolean;
};
const DevelopmentDemoContext = createContext<DevelopmentDemoValue | null>(null);
export function DevelopmentDemoProvider({
  config,
  children
}: {
  config: DevDomainConfig;
  children: React.ReactNode;
}) {
  const reducer = useMemo(() => createDevReducer(config), [config]);
  const createInitial = useMemo(() => () => createInitialDevState(config), [config]);
  const {
    state,
    dispatch,
    reset,
    persistenceOk
  } = useDemoStore(devStorageKey(config.id), reducer, createInitial);
  const value = useMemo(() => ({
    config,
    state,
    dispatch,
    reset,
    persistenceOk
  }), [config, state, dispatch, reset, persistenceOk]);
  return <DevelopmentDemoContext.Provider value={value} data-id="element-2745" data-mp="36hsty7ehkpco">{children}</DevelopmentDemoContext.Provider>;
}
export function useDevelopmentDemo() {
  const value = useContext(DevelopmentDemoContext);
  if (!value) throw new Error('useDevelopmentDemo must be used within DevelopmentDemoProvider');
  return value;
}